<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
            <div class="col-md-12">
            <div class="top-list-toolbar">
                <div>
                <h4 class="text-primary" @click="backParent">Stock Close</h4>
                <ol class="breadcrumb breadcrumb-card-header">
                    <li class="breadcrumb-item">
                    <a href="javascript:void(0);" @click="backParent">Stock Close</a>
                    </li>
                    <li class="breadcrumb-item active">
                    <span v-if="close.id === null">New</span>
                    <span v-else>{{ close.close_no }}</span>
                    </li>
                </ol>
                <button type="button" @click="update" class="btn btn-sm btn-soft-primary pull-left" v-show="close.close_no !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
                <button type="button" @click="create" class="btn btn-sm btn-soft-primary pull-left" v-show="close.close_no == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
                </div>
            </div>
            </div>
        </div>
        <div class="card card-list">
            <div class="card-header">
                <h5 v-if="close.close_no === null">New</h5>
                <h5 v-else>{{ close.close_no }}</h5>
            </div>
            <div class="card-body">
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                    <ul v-for="(a, index) in alert" :key="index">
                        <li v-html="a"></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <dl class="row dl-custom font-12">
                            <dt class="col-md-4">Close Date</dt>
                            <dd class="col-md-8">
                                <datetime v-model="close.close_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" ></datetime>
                            </dd>

                            <dt class="col-md-4">Company</dt>
                            <dd class="col-md-8">
                                <select v-model="close.company_no" class="form-control">
                                    <option value="">-- All --</option>
                                    <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                                </select>
                            </dd>

                            <dt class="col-md-4">Notes</dt>
                            <dd class="col-md-8">
                                <textarea v-model="close.notes" class="form-control"></textarea>
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </div>
        <pre>{{ close }}</pre>
        <!-- <div class="row justify-content-md-center">
            <div class="col-md-6">
                <h5>Logs:</h5>
                <div class="alert alert-info" role="alert" v-for="l in sales.logs" :key="l.id">
                    <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import { getHeader, productUrl } from '../../config'

export default {
  name: 'ProductStockCloseForm',
  props: ['close'],
  components: {
    Loading
  },
  data () {
    return {
      alert: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      companyList: state => state.companies.companyList
    })
  },
  methods: {
    async update () {
      await axios.post(productUrl + '/stock-close/' + this.close.id, this.close, { headers: getHeader() })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.reponse.data.message, 'error')
          throw error
        })
    },
    async create () {
      await axios.post(productUrl + '/stock-close', this.close, { headers: getHeader() })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.reponse.data.message, 'error')
          throw error
        })
    },
    backParent () {
      this.$emit('backClicked')
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
  .text-style {
    color: #28A745;
  }
</style>
